export const ENVIRONMENT_PRODUCTION = 'production';
export const ENVIRONMENT_NONPROD = 'nonprod';
export const ENVIRONMENT_DEVELOPMENT = 'development';
export const PROJECT_TYPE = 'Project';
export const CATEGORY_TYPE = 'Category';
export const PORT_DOMAIN = 'PORT';
export const TERMINAL_DOMAIN = 'TERMINAL';
export const SMOKE_DOMAIN = 'SMOKE';
export const RAIL_DOMAIN = 'RAIL';
//SCOPES
export const ProjectReadScope = 'projects:read';
//ICommandResult
export var COMMAND_STATUS;
(function (COMMAND_STATUS) {
    COMMAND_STATUS["OK"] = "OK";
    COMMAND_STATUS["FAILED"] = "FAILED";
    COMMAND_STATUS["NOTFOUND"] = "NOTFOUND";
})(COMMAND_STATUS || (COMMAND_STATUS = {}));
export const LIST_VIEW_MODES = {
    TILE: 'tile',
    LIST: 'list',
};
export const ARCHIVED = 'Archived';
export const UNARCHIVED = 'UnArchived';
export const LOCKED = 'LOCKED';
export const UNLOCKED = 'UNLOCKED';
export const DESCRIPTION_LENGTH = 1024;
export const NAME_LENGTH = 255;
export var ProjectActions;
(function (ProjectActions) {
    ProjectActions[ProjectActions["ShowDetails"] = 1] = "ShowDetails";
    ProjectActions[ProjectActions["ViewProjectList"] = 2] = "ViewProjectList";
    ProjectActions[ProjectActions["StartExperiment"] = 3] = "StartExperiment";
    ProjectActions[ProjectActions["StopExperiment"] = 4] = "StopExperiment";
    ProjectActions[ProjectActions["ShowInputData"] = 5] = "ShowInputData";
    ProjectActions[ProjectActions["ShowResults"] = 6] = "ShowResults";
    ProjectActions[ProjectActions["DeleteProject"] = 7] = "DeleteProject";
    ProjectActions[ProjectActions["DuplicateProject"] = 8] = "DuplicateProject";
    ProjectActions[ProjectActions["ViewScenarioList"] = 9] = "ViewScenarioList";
})(ProjectActions || (ProjectActions = {}));
//Original
// export const LOCAL_STORAGE_CONTEXT = 'context'
// export const CONTEXT = LOCAL_STORAGE_CONTEXT
// export const SCENARIO_CONTEXT = 'scenariocontext'
//New Version
export const LOCAL_STORAGE_CONTEXT = 'context';
export const CONTEXT = LOCAL_STORAGE_CONTEXT;
export const PROJECT_CONTEXT = 'projectcontext';
export const SCENARIO_CONTEXT = PROJECT_CONTEXT;
